/**
 * @file MusesModel
 * @author liuye11(liuye11@baidu.com)
 */

import BaseAppModel from '@baidu/ve-ria/views/AppModel';
import {startsWith} from 'lodash';

export default class AppModel extends BaseAppModel {

    isPM = false;
    isClientPage = false; // is client entry page
    isAdminPage = false; // is admin entry page

    setUserInfo() {
        // 行业PM判断
        let dev = this.getDev();
        this.isPM = String(dev.roleId) === '8';
    }

    setPageInfo() {
        // e.g: origin/client/html 返回 /client/html;
        let pathName = window.location.pathname;
        // 判断入口页面类型
        this.isClientPage = startsWith(pathName, '/client');
        this.isAdminPage = startsWith(pathName, '/admin');
    }
}
